export enum TenderStatus {
  Authorized = 'authorized',
  PreTender = 'preTender',
}
